import GroupAddIcon from "@mui/icons-material/GroupAdd";
import "./CollateralDetails.css";
import { useState, useEffect } from "react";
import Sidebar from "../../../Sidebar/Sidebar";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { useLocation } from "react-router-dom";
import { url } from "../../../App";
import Cookies from "js-cookie";

const ViewCollateralDetails = () => {
  const token = Cookies.get("Token");
  const email = Cookies.get("Email");
  const [isOpen, setIsOpen] = useState(true);
  const openView = (val) => setIsOpen(val);
  const [selectBorrower, setSelectBorrower] = useState("");
  const [collateralLoanId, setCollateralLoanId] = useState("");
  const [collateral_ownership, setcollateral_ownership] = useState("");
  const [collateralPropertyNumber, setCollateralPropertyNumber] = useState("");
  const [collateralPropertyOwnerName, setCollateralPropertyOwnerName] = useState("");
  const [collateralAddress, setCollateralAddress] = useState("");
  const [collateralState, setCollateralState] = useState("");
  const [collateralCity, setCollateralCity] = useState("");
  const [collateralPincode, setCollateralPincode] = useState("");
  const [collateralSubDist, setCollateralSubDist] = useState("");
  const [collateralLocality, setCollateralLocality] = useState("");
  const [collateralPurpose, setCollateralPurpose] = useState("");
  const [hlDetails, sethlDetails] = useState("");
  const [collateral_fair_market_value, setcollateral_fair_market_value] = useState("");
  const [collateral_stressed_value, setcollateral_stressed_value] = useState("");
  const [collateral_realizable_value, setcollateral_realizable_value] = useState("");
  const [collateral_age_of_property, setcollateral_age_of_property] = useState("");
  const [collateral_land_area_sqft, setcollateral_land_area_sqft] = useState("");
  const [collateral_land_area_sqmtr, setcollateral_land_area_sqmtr] = useState("");
  const [collateral_build_area, setcollateral_build_area] = useState("");
  const [collateral_latitude, setcollateral_latitude] = useState("");
  const [collateral_longitude, setcollateral_longitude] = useState("");
  const [collateral_land_purchase_date, setcollateral_land_purchase_date] =useState("");
  const [collateral_sale_deed_value, setcollateral_sale_deed_value] = useState("");
  const [
    collateral_construction_start_date,
    setcollateral_construction_start_date,
  ] = useState("");
  const [
    collateral_sanction_approval_status,
    setcollateral_sanction_approval_status,
  ] = useState("");
  const [collateral_estimated_cost, setcollateral_estimated_cost] =
    useState("");
  const [collateral_construction_area, setcollateral_construction_area] =
    useState("");
  const [
    collateral_stage_of_construction,
    setcollateral_stage_of_construction,
  ] = useState("");
  const [
    collateral_stage_of_construction_percent,
    setcollateral_stage_of_construction_percent,
  ] = useState("");
  const [collateral_vetted_cost, setcollateral_vetted_cost] = useState("");
  const [collateral_market_value, setcollateral_market_value] = useState("");
  const [
    collateral_nature_of_improvement,
    setcollateral_nature_of_improvement,
  ] = useState("");
  const [collateral_improvement_cost, setcollateral_improvement_cost] =
    useState("");
  const [
    collateral_improvement_cost_percent,
    setcollateral_improvement_cost_percent,
  ] = useState("");
  const [collateral_nature_of_expansion, setcollateral_nature_of_expansion] =
    useState("");
  const [collateral_expansion_cost, setcollateral_expansion_cost] =
    useState("");
  const [
    collateral_expansion_cost_percent,
    setcollateral_expansion_cost_percent,
  ] = useState("");
  const [collateral_expansion_area, setcollateral_expansion_area] =
    useState("");
  const [collateral_expansion_reason, setcollateral_expansion_reason] =
    useState("");
  const [selectCollateralType, setSelectCollateralType] = useState("");

  const { state } = useLocation();
  console.log(state);

  useEffect(() => {
    axios
      .post(url + "/collateral/getsingle", {
        token: token,
        email: email,
        collateral_id: state.collateral_id,
      })
      .then((res) => {
        console.log(res);
        setSelectCollateralType(res.data[0]?.collateral_type);
        setSelectBorrower(res.data[0]?.collateral_borrower_uniqueno);
        setCollateralLoanId(res.data[0]?.collateral_loan_id);
        setcollateral_ownership(res.data[0]?.collateral_ownership);
        setCollateralPropertyNumber(res.data[0]?.collateral_property_number);
        setCollateralPropertyOwnerName(res.data[0]?.collateral_property_owner_name);
        setCollateralAddress(res.data[0]?.collateral_address);
        setCollateralState(res.data[0]?.collateral_state);
        setCollateralCity(res.data[0]?.collateral_city);
        setCollateralLocality(res.data[0]?.collateral_locality);
        setCollateralSubDist(res.data[0]?.collateral_subDistrict);
        setCollateralPincode(res.data[0]?.collateral_pincode);
        setcollateral_land_area_sqft(res.data[0]?.collateral_property_area_ft);
        setcollateral_land_area_sqmtr(res.data[0]?.collateral_property_area_mtr);
        setcollateral_fair_market_value(
          res.data[0]?.collateral_fair_market_value
        );
        setcollateral_stressed_value(res.data[0]?.collateral_stressed_value);
        setcollateral_realizable_value(res.data[0]?.collateral_realizable_value);
        setcollateral_age_of_property(res.data[0]?.collateral_age_of_property);
        setcollateral_build_area(res.data[0]?.collateral_build_up_area_sqft);
        setcollateral_construction_start_date(
          res.data[0]?.collateral_construction_start_date
        );
        setcollateral_latitude(res.data[0]?.collateral_latitude);
        setcollateral_longitude(res.data[0]?.collateral_longitude);
        setCollateralPurpose(res.data[0]?.collateral_purpose);
        sethlDetails(res.data[0]?.collateral_hl_purpose);
        setcollateral_land_purchase_date(
          res.data[0]?.collateral_land_purchase_date
        );
        setcollateral_sale_deed_value(
          res.data[0]?.collateral_land_purchase_sale_deed_value
        );
        setcollateral_construction_start_date(
          res.data[0]?.collateral_construction_start_date
        );
        setcollateral_sanction_approval_status(res.data[0]?.collateral_plans);
        setcollateral_estimated_cost(
          res.data[0]?.collateral_estimated_construction_cost
        );
        setcollateral_construction_area(
          res.data[0]?.collateral_total_construction_area
        );
        setcollateral_stage_of_construction(
          res.data[0]?.collateral_stage_of_construction
        );
        setcollateral_stage_of_construction_percent(
          res.data[0]?.collateral_stage_of_construction_percentage
        );
        setcollateral_vetted_cost(
          res.data[0]?.collateral_vetted_cost_of_construction
        );
        setcollateral_market_value(res.data[0]?.collateral_market_value_of_land);
        setcollateral_nature_of_improvement(
          res.data[0]?.collateral_nature_of_improvement
        );
        setcollateral_improvement_cost(res.data[0]?.collateral_improvement_cost);
        setcollateral_improvement_cost_percent(
          res.data[0]?.collateral_improvement_cost_percentage
        );
        setcollateral_nature_of_expansion(
          res.data[0]?.collateral_nature_of_expansion
        );
        setcollateral_expansion_cost(res.data[0]?.collateral_expansion_cost);
        setcollateral_expansion_cost_percent(
          res.data[0]?.collateral_expansion_cost_percentage
        );
        setcollateral_expansion_area(res.data[0]?.collateral_expansion_area);
        setcollateral_expansion_reason(res.data[0]?.collateral_expansion_reason);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [token, email, state]);

  return (
    <>
      <div style={{ height: "20px" }} />
      <Sidebar click={openView} />
      <div style={{ marginLeft: isOpen ? "15%" : "0", transition: "all 0.2s" }}>
        <div className="main-container">
          <div className="content-container">
            <h3 className="main-heading">
              <GroupAddIcon />
              View Collateral Details
            </h3>
            <div className="collateral-details-first">
              <div>
                <p>
                  <strong>Borrower ID:</strong>&nbsp;&nbsp;{selectBorrower}
                </p>
              </div>
              <div>
                <p>
                  <strong>Loan ID:</strong>&nbsp;&nbsp;{collateralLoanId}
                </p>
              </div>
              <div>
                <p>
                  <strong>Ownership:</strong>&nbsp;&nbsp;{collateral_ownership}
                </p>
              </div>
              <div>
                <p>
                  <strong>Property Number:</strong>&nbsp;&nbsp;
                  {collateralPropertyNumber}
                </p>
              </div>
              <div>
                <p>
                  <strong>Property Owner's Name:</strong>&nbsp;&nbsp;
                  {collateralPropertyOwnerName}
                </p>
              </div>
            </div>

            <h3 className="heading">Collateral Address Details</h3>
            <div className="collateral-details-second">
              <div>
                <p>
                  <strong>Collateral Type:</strong>&nbsp;&nbsp;
                  {selectCollateralType}
                </p>
              </div>
              <div>
                <p>
                  <strong>Address:</strong>&nbsp;&nbsp;{collateralAddress}
                </p>
              </div>
              <div>
                <p>
                  <strong>PIN Code:</strong>&nbsp;&nbsp;{collateralPincode}
                </p>
              </div>
              <div>
                <p>
                  <strong>State:</strong>&nbsp;&nbsp;
                  {collateralState}
                </p>
              </div>
              <div>
                <p>
                  <strong>City:</strong>&nbsp;&nbsp;
                  {collateralCity}
                </p>
              </div>
              <div>
                <p>
                  <strong>Sub District:</strong>&nbsp;&nbsp;
                  {collateralSubDist}
                </p>
              </div>
              <div>
                <p>
                  <strong>Locality/Village:</strong>&nbsp;&nbsp;
                  {collateralLocality}
                </p>
              </div>
              <div>
                <p>
                  <strong>Latitude:</strong>&nbsp;&nbsp;
                  {collateral_latitude}
                </p>
              </div>
              <div>
                <p>
                  <strong>Longitude:</strong>&nbsp;&nbsp;
                  {collateral_longitude}
                </p>
              </div>
            </div>
            
            <h3 className="heading">Collateral Details</h3>

            <div className="collateral-details-second">
              {collateralPurpose === "LAP" ? (
                <>
                  <div>
                    <p>
                      <strong>Age of Property:</strong>&nbsp;&nbsp;
                      {collateral_age_of_property}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Land Area (in sq. ft):</strong>&nbsp;&nbsp;
                      {collateral_land_area_sqft}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Land Area (in sq mtrs):</strong>&nbsp;&nbsp;
                      {collateral_land_area_sqmtr}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Build Up Area (sq. ft.):</strong>&nbsp;&nbsp;
                      {collateral_build_area}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Stressed value:</strong>&nbsp;&nbsp;
                      {collateral_stressed_value}
                    </p>
                  </div>

                  <div>
                    <p>
                      <strong>Realizable value:</strong>&nbsp;&nbsp;
                      {collateral_realizable_value}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Fair Market Value:</strong>&nbsp;&nbsp;
                      {collateral_fair_market_value}
                    </p>
                  </div>
                </>
              ) : (
                ""
              )}

              {collateralPurpose === "HL" &&
              hlDetails === "self_construction" ? (
                <>
                  <div>
                    <p>
                      <strong>Land Purchase Date:</strong>&nbsp;&nbsp;
                      {collateral_land_purchase_date
                        ? collateral_land_purchase_date.slice(0, 10)
                        : ""}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Land Purchase/Sale Deed Value:</strong>&nbsp;&nbsp;
                      {collateral_sale_deed_value}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Construction Start Date:</strong>&nbsp;&nbsp;
                      {collateral_construction_start_date
                        ? collateral_construction_start_date.slice(0, 10)
                        : ""}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Plan/Sanction Approval Status:</strong>&nbsp;&nbsp;
                      {collateral_sanction_approval_status}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Estimated Cost of Construction Per Sqr Ft:</strong>
                      &nbsp;&nbsp;
                      {collateral_estimated_cost}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Total Construction Area:</strong>&nbsp;&nbsp;
                      {collateral_construction_area}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Stage of Construction:</strong>&nbsp;&nbsp;
                      {collateral_stage_of_construction}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Stage of Construction%:</strong>&nbsp;&nbsp;
                      {collateral_stage_of_construction_percent}
                    </p>
                  </div>

                  <div>
                    <p>
                      <strong>Land Area (inSqrFt):</strong>&nbsp;&nbsp;
                      {collateral_land_area_sqft}
                    </p>
                  </div>

                  <div>
                    <p>
                      <strong>Vetted Cost of Construction:</strong>&nbsp;&nbsp;
                      {collateral_vetted_cost}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Market Value of Land:</strong>&nbsp;&nbsp;
                      {collateral_market_value}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Stressed value:</strong>&nbsp;&nbsp;
                      {collateral_stressed_value}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Realizable value:</strong>&nbsp;&nbsp;
                      {collateral_realizable_value}
                    </p>
                  </div>
                </>
              ) : (
                ""
              )}

              {collateralPurpose === "HL" && hlDetails === "improvement" ? (
                <>
                  <div>
                    <p>
                      <strong>Nature of Improvement:</strong>&nbsp;&nbsp;
                      {collateral_nature_of_improvement}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Improvement Cost:</strong>&nbsp;&nbsp;
                      {collateral_improvement_cost}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>
                        Improvement Cost % (Cost to Property Value):
                      </strong>
                      &nbsp;&nbsp;
                      {collateral_improvement_cost_percent}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Plan/Sanction Approval Status:</strong>
                      &nbsp;&nbsp;
                      {collateral_sanction_approval_status}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Age of Property:</strong>&nbsp;&nbsp;
                      {collateral_age_of_property}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Land Area (in sq. ft):</strong>&nbsp;&nbsp;
                      {collateral_land_area_sqft}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Land Area (in sq mtrs):</strong>&nbsp;&nbsp;
                      {collateral_land_area_sqmtr}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Build Up Area (sq. ft.):</strong>&nbsp;&nbsp;
                      {collateral_build_area}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Stressed value:</strong>&nbsp;&nbsp;
                      {collateral_stressed_value}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Realizable value:</strong>&nbsp;&nbsp;
                      {collateral_realizable_value}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Fair Market Value:</strong>&nbsp;&nbsp;
                      {collateral_fair_market_value}
                    </p>
                  </div>
                </>
              ) : (
                ""
              )}

              {collateralPurpose === "HL" && hlDetails === "expansion" ? (
                <>
                  <div>
                    <p>
                      <strong>Nature of Expansion:</strong>&nbsp;&nbsp;
                      {collateral_nature_of_expansion}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Expansion Cost:</strong>&nbsp;&nbsp;
                      {collateral_expansion_cost}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>
                        Expansion Cost % (Cost to Property Value):
                      </strong>
                      &nbsp;&nbsp;
                      {collateral_expansion_cost_percent}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Expansion Area:</strong>&nbsp;&nbsp;
                      {collateral_expansion_area}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Expansion Reason:</strong>&nbsp;&nbsp;
                      {collateral_expansion_reason}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Plan/Sanction Approval Status:</strong>
                      &nbsp;&nbsp;
                      {collateral_sanction_approval_status}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Age of Property:</strong>&nbsp;&nbsp;
                      {collateral_age_of_property}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Land Area (in sq. ft):</strong>&nbsp;&nbsp;
                      {collateral_land_area_sqft}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Land Area (in sq mtrs):</strong>&nbsp;&nbsp;
                      {collateral_land_area_sqmtr}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Build Up Area (sq. ft.):</strong>&nbsp;&nbsp;
                      {collateral_build_area}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Stressed value:</strong>&nbsp;&nbsp;
                      {collateral_stressed_value}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Realizable value:</strong>&nbsp;&nbsp;
                      {collateral_realizable_value}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>Fair Market Value:</strong>&nbsp;&nbsp;
                      {collateral_fair_market_value}
                    </p>
                  </div>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewCollateralDetails;
